import React, { useState , useContext} from "react";
import "./MakeAnAnnouncement.css";
import "../Modals.css";
import { test } from "../../../Status";
import { renderStatementWithKaTeX } from "../../../Status";
import { MakeAnnouncement } from "../../../Functions/CRUD/Announcement/announcementHelper";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../context/authContext";

const MakeAnAnnouncement = ({ setMakeAnnouncement }) => {
  const navigate = useNavigate();
  const [type, setType] = useState("");
  const [title, setTitle] = useState("");
  const [Content, setContent] = useState("");
  const {user} = useContext(AuthContext)

  const handleSubmit = async (e) => {
    e.preventDefault();
    const today = new Date();

    const TodayDate = today.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "2-digit",
    });

    // ✅ FIXED payload
    const messageData = {
      Date: TodayDate.toString(),
      Title: title,
      Type: type,
      Content: Content, // 👈 fixed spelling
      Poster: {
        id: user._id,
        name: user.username,
      },
    };

    try {
      const response = await MakeAnnouncement(messageData);
      console.log("Announcement created:", response);

      setTitle("");
      setType("");
      setContent("");
      setMakeAnnouncement(false);

      window.scrollTo({ top: 0, behavior: "smooth" });

      navigate(0);
      navigate(window.location.pathname, { replace: true });
    } catch (err) {
      console.error("Error creating announcement:", err);
    }
  };

  return (
    <div className="MakeAnAnnouncement">
      <div className="MakeAnAnnouncement-conatiner Modal-Container">
        <div className="MakeAnAnnouncement Modal">
          <div className="Headding">
            <h1>Make An Announcement</h1>
            <span
              className="close-btn"
              onClick={() => setMakeAnnouncement(false)}
            >
              &times;
            </span>
          </div>
          <div className="Information-Section">
            <form className="announcement-form" onSubmit={handleSubmit}>
              <label htmlFor="type">Type:</label>
              <select
                id="type"
                value={type}
                onChange={(e) => setType(e.target.value)}
                required
              >
                <option value="" disabled>
                  Select a type
                </option>
                <option value="News">News</option>
                <option value="Article">Article</option>
              </select>

              <label htmlFor="title">Title:</label>
              <input
                type="text"
                id="title"
                placeholder="Enter the title..."
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                required
              />

              <label htmlFor="content">Content:</label>
              <div className="DisplayBox">
                {renderStatementWithKaTeX(Content)}
              </div>
              <textarea
                id="content"
                placeholder="Write the content here..."
                value={Content}
                onChange={(e) => setContent(e.target.value)}
                rows={8}
                required
              />

              <button className="Submit">Submit</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MakeAnAnnouncement;
